import type { AxiosResponse } from 'axios';
import * as React from 'react';
import { useQuery } from 'react-query';
import { v4 as uuid } from 'uuid';

import { CONNECT_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import type {
  AppLibraryDataResponse,
  AppTileType,
} from '@/components/ConnectApps/Common/types';

export const QUERY_KEY = 'integration';

export const useSearchWebsites = (topic: string) => {
  const placeholderData: AppTileType[] = React.useMemo(
    () =>
      Array.from({ length: 5 }).map((_, i) => ({
        isLoading: true,
        category: '',
        disabled: false,
        flag: false,
        label: uuid(),
        value: '',
        private: false,
        tokenValid: false,
        feedly_data: {
          feedId: '',
          subscribers: 0,
          title: '',
          topics: [`topic-${i}`],
        },
      })),
    []
  );

  const { data, isLoading, isError } = useQuery<
    AxiosResponse<AppLibraryDataResponse>,
    unknown,
    AppTileType[]
  >(
    [QUERY_KEY, topic],
    ({ signal }) =>
      axiosInstance.get(CONNECT_API_ROUTES.rss(), {
        params: { topic },
        signal,
      }),
    {
      select: ({ data }) => data.results,
      enabled: !!topic,
      cacheTime: 0,
    }
  );

  return { data, isLoading, placeholderData, isError };
};
